// src/pages/copilot/components/ChatMessage.jsx
import { Bot, AlertTriangle } from 'lucide-react';

export default function ChatMessage({ message }) {
  const { role, kind, content } = message;
  if (role === 'user') {
    const text = (content?.text || '').trim();
    if (!text) return null;
    return (
      <div className="chat-message user">
        <div className="message-content">
          <div className="message-text">{text}</div>
        </div>
        <div className="message-avatar user"><span>U</span></div>
      </div>
    );
  }
  let body = null;
  if (kind === 'error') {
    body = (
      <div className="message-error">
        <AlertTriangle size={16} />
        <span>{content?.text || 'Something went wrong. Please try again.'}</span>
      </div>
    );
  } else {
    // kind === 'text' (default). `.message-text` already uses
    // white-space: pre-wrap, so plain text renders line breaks correctly.
    body = <div className="message-text">{content?.text || ''}</div>;
  }
  return (
    <div className="chat-message assistant">
      <div className="message-avatar"><Bot size={20} /></div>
      <div className="message-content">{body}</div>
    </div>
  );
}
